import React from 'react';
import { TextField, Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PaymentSection = ({ 
  totalIncl, 
  invoicePaidAmount, 
  setInvoicePaidAmount,
  error = false, 
  onFocus,
  disabled = false,
  onFullPayment
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* Total Amount Field - First */}
      <Box sx={{ 
        mb: 2,
        p: 1.5, 
        bgcolor: 'info.lighter', 
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'info.light'
      }}>
        <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
          {t("total_amount")}:
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="info.main">
          €{totalIncl.toFixed(2)}
        </Typography>
      </Box>

      {/* Full Payment Button - Second */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          size="medium"
          onClick={onFullPayment}
          disabled={disabled}
          sx={{
            textTransform: 'none',
            borderRadius: '10px',
            fontWeight: 600,
            color: '#fff',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5568d3 0%, #6a3f91 100%)',
            },
          }}
        >
          {t("full_payment") || "Full Payment"}
        </Button>
      </Box>

      {/* Paid Amount Field - Third */}
      <TextField
        fullWidth
        type="number"
        label={t("paid_amount")}
        value={invoicePaidAmount}
        onChange={(e) => setInvoicePaidAmount(e.target.value)}
        onFocus={onFocus}
        placeholder="0.00"
        disabled={disabled}
        error={error}
        helperText={error ? t("paid_amount_required") : (disabled ? t("add_products_first") || "Add products to enable payment" : "")}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
          },
          // ✅ Ensure red border when error
          '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: 'error.main',
            borderWidth: '2px',
          }
        }}
        InputProps={{
          startAdornment: <Box sx={{ mr: 1 }}>€</Box>
        }}
      />
    </Box>
  );
};

export default PaymentSection;